export const descargarArchivo = (response) => {
    if (response.url) {
        window.open(response.url, '_blank');
        return;
    }

    const link = document.createElement('a');
    link.download = response.filename;
    link.href = `data:${response.mimetype};base64,${response.file}`;
    link.click();
};
